var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragAndDropSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reward-Categories",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Reward-Categories-#17---Edit-2",
    transform: "translate(-1039.000000, -517.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(88.000000, 504.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(951.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 35,
    height: 35,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(7.000000, 4.000000)",
    fill: "#333852",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "compose"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6642336,2.3081914 L21.6918086,0.335766423 C21.2376318,-0.111922141 20.5109489,-0.111922141 20.0632603,0.335766423 L18,2.39902676 L21.6009732,6 L23.6642336,3.9432279 C24.1119221,3.48256285 24.1119221,2.75587997 23.6642336,2.3081914 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "17.6022444 3 6.87905237 14.0248447 6 18 9.99002494 17.1242236 21 6.37888199"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0909091,12.5454545 L19.0909091,21.4943182 C19.0909091,21.7985795 18.8582386,22.096875 18.5420455,22.096875 C18.2258523,22.096875 2.49375,22.0909091 2.49375,22.0909091 C2.15965909,22.0909091 1.90909091,21.76875 1.90909091,21.4943182 C1.90909091,21.2198864 1.90909091,5.50568182 1.90909091,5.50568182 C1.90909091,5.20738636 2.18948864,4.90909091 2.54147727,4.90909091 L11.4545455,4.90909091 L13.3636364,3 L1.39602273,3 C0.620454545,3 0,3.61448864 0,4.39005682 L0,22.6039773 C0,23.3735795 0.626420455,24 1.39602273,24 L19.6099432,24 C20.3795455,24 21,23.3735795 21,22.6039773 L21,10.6363636 L19.0909091,12.5454545 Z",
    id: "Path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragAndDropSelected);
export default __webpack_public_path__ + "static/media/dragAndDropSelected.a41ccf3236937e1223c2c094d60093db.svg";
export { ForwardRef as ReactComponent };